import React from 'react';
import ReactDOM from 'react-dom';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function RotateUniversalBanner(this: any) {
  this.index = 0;
  this.content = [];
  this.changeContent = null;
  this.playPauseButton = null;
}

RotateUniversalBanner.prototype.setPlayButtonColor = function () {
  const svg = document.querySelector('.play-pause-button svg');
  svg && (svg.style.fill = getComputedStyle(this.content[this.index]).color);
};

RotateUniversalBanner.prototype.autoplay = function () {
  this.changeContent = setInterval(() => {
    this.content[this.index].classList.remove('fade-in');
    this.index = this.index === this.content.length - 1 ? 0 : this.index + 1;
    this.content[this.index].classList.add('fade-in');
    this.setPlayButtonColor();
  }, 5000);
};

RotateUniversalBanner.prototype.pauseAutoplay = function () {
  clearInterval(this.changeContent);
};

RotateUniversalBanner.prototype.setButtonIcon = function (isPaused: Boolean) {
  ReactDOM.render(
    isPaused ? <span className="alo-pause-icon"></span> : <span className="alo-play-icon"></span>,
    this.playPauseButton
  );
};

RotateUniversalBanner.prototype.init = function () {
  const bannerNodes = [...document.querySelectorAll('.uni-banner__text')];
  this.content = bannerNodes.filter(
    (banner) => banner.style.display === 'inherit' || getComputedStyle(banner).display !== 'none'
  );

  const bannersSection = document.querySelector('.uni-banner');
  if (this.content.length === 0 || !bannersSection) {
    bannersSection && (bannersSection.style.display = 'none');
    return;
  }

  this.content[this.index].classList.add('fade-in');
  this.playPauseButton = document.querySelector('.play-pause-button');

  if (this.content.length > 1) {
    this.setButtonIcon(false);
    this.setPlayButtonColor();
    this.autoplay();
    this.playPauseButton.addEventListener('click', () => {
      if (this.playPauseButton.classList.contains('pause')) {
        this.playPauseButton.classList.remove('pause');
        this.autoplay();
      } else {
        this.playPauseButton.classList.add('pause');
        this.pauseAutoplay();
      }
      this.setButtonIcon(this.playPauseButton.classList.contains('pause'));
      this.setPlayButtonColor();
    });
  } else {
    this.playPauseButton?.parentNode.removeChild(this.playPauseButton);
    bannerNodes.forEach((text) => {
      text.style.maxWidth = '100%';
      text.style.padding = '0 15px';
    });
  }
};
